import React from "react";
import LegalLayout, { H2, P, UL } from "./LegalLayout";

export default function Refund() {
  return (
    <LegalLayout title="Refund & Cancellation" subtitle="Legal · 03" lastUpdated="February 2026">
      <P>
        This policy describes how subscriptions and operations may be cancelled and under which
        circumstances refunds are issued. By becoming a Member you accept the following terms.
      </P>

      <H2>1. Subscription Cancellation</H2>
      <UL>
        <li>You may cancel a CAMO subscription at any time by contacting CAMO via Discord (@felopic) or
          Instagram (@camointelligence).</li>
        <li>Cancellation takes effect at the end of the current paid billing cycle.</li>
        <li>You retain access to your Member tier until that cycle ends.</li>
      </UL>

      <H2>2. EU Right of Withdrawal (14 days)</H2>
      <P>
        Where you qualify as a consumer under EU law (Directive 2011/83/EU), you have the right to withdraw
        from the contract within 14 days from purchase without giving reason. To exercise this right,
        contact CAMO via Discord or Instagram with a clear statement of withdrawal.
      </P>
      <P>
        <strong>Exception — immediate service delivery:</strong> by purchasing a CAMO subscription you
        expressly request that CAMO begin providing services before the 14-day period expires. You
        acknowledge that, upon full performance of the service within the withdrawal period, you lose your
        right of withdrawal under Article 16(a) of the Directive. If services have been partially performed,
        you will be charged pro-rata for the portion already delivered.
      </P>

      <H2>3. Non-Refundable Items</H2>
      <UL>
        <li>Completed on-demand operations.</li>
        <li>Intelligence reports already delivered.</li>
        <li>Strategic consultations already held.</li>
        <li>Bespoke deliverables produced to client specification.</li>
      </UL>

      <H2>4. Refund Eligibility</H2>
      <P>Full or partial refunds may be considered where:</P>
      <UL>
        <li>Service was not provided due to a CAMO operational error.</li>
        <li>A duplicate or erroneous charge was processed.</li>
        <li>Required by mandatory consumer-protection law.</li>
      </UL>
      <P>
        Refund requests must be submitted within 30 days of the contested charge. Approved refunds are
        processed via the original payment method (PayPal). Processing time: up to 14 business days.
      </P>

      <H2>5. Chargebacks</H2>
      <P>
        Initiating a chargeback without first contacting CAMO will result in immediate termination of
        membership and forfeiture of any pending deliverables. We reserve the right to dispute chargebacks
        with evidence of service performance.
      </P>

      <H2>6. Service Suspension</H2>
      <P>
        CAMO reserves the right to suspend or terminate any account engaged in conduct prohibited under the
        Terms of Service (Section 4 — Acceptable Use) without refund.
      </P>

      <H2>7. Contact for Refunds</H2>
      <P>Discord: @felopic · Instagram: @camointelligence</P>
    </LegalLayout>
  );
}
